import {
  BlogMetadataIntegrationState,
  BlogMetadataIntegrationHandlers,
} from '../../../hooks/useBlogMetadataIntegration'
import Styles from '../../../BlogMetadata.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { WixProfile } from 'api/clients/ExternalIntegrationsClient'
import { WixAuthorSelect } from '../WixAuthorSelect/WixAuthorSelect'

interface WixIntegrationFieldsProps {
  integrationState: BlogMetadataIntegrationState
  handlers: BlogMetadataIntegrationHandlers
  isPostPublished: boolean
}

export const WixIntegrationFields: React.FC<WixIntegrationFieldsProps> = ({
  integrationState,
  handlers,
  isPostPublished,
}) => {
  const { selectedIntegration, selectedAuthorId, availableAuthors } = integrationState
  const { handleAuthorSelect } = handlers

  // Get Wix site info from the integration
  const wixProfile = selectedIntegration?.additional_data as WixProfile | undefined
  const wixSiteUrl = wixProfile?.site_url || 'Unknown Site'

  return (
    <>
      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Blog</label>
        <div className={Styles.categoryDropdown}>
          <Text variant="secondary">{wixSiteUrl}</Text>
        </div>
      </div>

      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Writer</label>
        <div className={Styles.categoryDropdown}>
          <WixAuthorSelect
            members={availableAuthors}
            selectedAuthorId={selectedAuthorId}
            onAuthorSelect={handleAuthorSelect}
            disabled={isPostPublished}
          />
        </div>
      </div>
    </>
  )
}
